import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@ui/accordion";

interface AccordionProps {
  data: {
    id: string;
    trigger: React.ReactNode;
    content: React.ReactNode;
  }[];
  containerClassName?: string;
  triggerClassName?: string;
  itemClassName?: string;
  contentClassName?: string;
  type?: "single" | "multiple";
  activeTriggerClassName?: string;
  activeState?: number;
  setActiveState?: (state: number) => void;
}
export const ShadcnAccordion = ({
  data,
  containerClassName,
  itemClassName,
  triggerClassName,
  contentClassName,
  type = "multiple",
  activeTriggerClassName,
  activeState,
  setActiveState,
}: AccordionProps) => {
  return (
    <Accordion type={type} className={`w-full ${containerClassName}`}>
      {data?.length > 0 &&
        data.map(({ id, trigger, content }) => (
          <AccordionItem
            value={id}
            key={id}
            className={`${triggerClassName} ${
              parseInt(id) == activeState && activeTriggerClassName
            }`}
            onClick={() =>
              setActiveState ? setActiveState(parseInt(id)) : null
            }
          >
            <AccordionTrigger className={itemClassName}>
              {trigger}
            </AccordionTrigger>
            <AccordionContent className={contentClassName}>
              {content}
            </AccordionContent>
          </AccordionItem>
        ))}
    </Accordion>
  );
};
